// toast.js
let showToastFn;

export const registerToast = (fn) => {
  showToastFn = fn;
};

export const toast = {
  success: (msg, duration = 3000) => showToastFn?.(msg, "success", duration),
  error: (msg, duration = 3000) => showToastFn?.(msg, "error", duration),
  info: (msg, duration = 3000) => showToastFn?.(msg, "info", duration),
  warning: (msg, duration = 3000) => showToastFn?.(msg, "warning", duration),
};
